
import { ThemeProvider } from "@/components/ThemeProvider";
import { LanguageProvider } from "@/context/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { GDPRBanner } from "@/components/GDPRBanner";
import { useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <ThemeProvider defaultTheme="dark" storageKey="portfolio-theme">
      <LanguageProvider>
        <div className="min-h-screen bg-background text-foreground">
          <Navbar />
          <Toaster />
          <AnimatePresence mode="wait">
            <main>{children}</main>
          </AnimatePresence>
          <Footer />
          <GDPRBanner />
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
};
